import React, { SVGProps } from 'react';
import { cn } from '@utils/cn';

export const AlertCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    {...props}
    className={cn('text-icon-error', props.className)}
  >
    <circle cx="28" cy="28" r="28" fill="currentColor" />
    <path
      d="M28 18V30"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="28" cy="38" r="2" fill="white" />
  </svg>
);
